import { Component, OnInit } from '@angular/core'
import { AuthorizeService } from '../../../service/authorize.service'
import { CpmService } from '../../../service/cpm.service'
import { StoreService } from '../../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-revenue-contribution-data',
  templateUrl: './revenue-contribution-data.component.html',
  styleUrls: ['./revenue-contribution-data.component.scss']
})
export class RevenueContributionDataComponent implements OnInit {
  listHeader = []
  listTable
  header = []
  type = []
  listDirectRevenue = []
  listIndirectRevenue = []
  listTotal = []
  headerTotal = []
  headerIndirect = []
  headerDirect = []
  listShowDirectRevenue = []
  listShowIndirectRevenue = []
  showTotalValue = []
  checkString = false
  excelRevenue = []
  companyId = 1
  round = 4
  total = []
  listTotalDirect = []
  listTotalIndirect = []
  showTotalRevenueValue = []
  totalRevenuePercent = []
  checkData = false
  remark = ''
  checkRemark = false
  constructor(
    private authorization: AuthorizeService,
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.store.getSecurityProfileNewResultObservable().subscribe(response => {
      if (!response) {
        return
      }
      this.onChangeData(response['securitySymbol'])
    })
  }
  onChangeData(symbol) {
    this.listTable = []
    this.cpmService.getRevenueContribution(symbol, this.round).then(success => {
      this.listTable = success
      this.listTable.length === 0
        ? (this.checkData = true)
        : (this.checkData = false)
      this.listHeader = []
      this.total = []
      this.listTotalDirect = []
      this.listTotalIndirect = []
      this.listTable.map(obj => {
        const listTotal = []
        obj.data.map(type => {
          if (type.type === 'Direct revenue') {
            if (type.data.length > 0) {
              const totalDirect = []
              type.data.map(value => {
                totalDirect.push(value.value)
              })
              listTotal.push(this.forTotal(totalDirect))
              const dataTotalDirect = {
                year: obj.year,
                total: this.forTotal(totalDirect)
              }
              this.listTotalDirect.push(dataTotalDirect)
            }
          } else if (type.type === 'Indirect revenue') {
            if (type.data.length > 0) {
              const totalIndirect = []
              type.data.map(value => {
                totalIndirect.push(value.value)
              })
              listTotal.push(this.forTotal(totalIndirect))
              const dataTotalIndirect = {
                year: obj.year,
                total: this.forTotal(totalIndirect)
              }
              this.listTotalIndirect.push(dataTotalIndirect)
            }
          }
        })
        const dataTotal = {
          year: obj.year,
          total: this.forTotal(listTotal)
        }
        this.total.push(dataTotal)
      })
      this.total.map(total => {
        this.listTable.map(lsTable => {
          if (total.year === lsTable.year) {
            lsTable.data.map(data => {
              data.data.map(value => {
                if (total.total !== 0) {
                  value['percent'] = (value.value / total.total) * 100
                } else if (total.total === 0) {
                  value['percent'] = 0
                }
              })
            })
          }
        })
      })
      this.listTable.map(lsTable => {
        lsTable.data.map(data => {
          this.total.map(total => {
            if (data.type === 'Direct revenue') {
              if (data.data.length > 0) {
                this.listTotalDirect.map(totalDirect => {
                  if (total.year === totalDirect.year) {
                    totalDirect['percent'] =
                      (totalDirect.total / total.total) * 100
                    totalDirect['total'] === 0
                      ? (totalDirect['percent'] = 0)
                      : Math.round(totalDirect.total)
                  }
                })
              }
            }
            if (data.type === 'Indirect revenue') {
              if (data.data.length > 0) {
                this.listTotalIndirect.map(totalIndirect => {
                  if (total.year === totalIndirect.year) {
                    totalIndirect['percent'] =
                      (totalIndirect.total / total.total) * 100
                    totalIndirect['total'] === 0
                      ? (totalIndirect['percent'] = 0)
                      : Math.round(totalIndirect.total)
                  }
                })
              }
            }
          })
        })
      })
      this.headerDirect = []
      this.headerIndirect = []
      this.listTotal = []
      this.listTable.map(obj => {
        this.header.push(obj.year)
        obj.data.map(type => {
          this.type.push(type.type)
          if (type.type === 'Direct revenue') {
            type.data.map(data => {
              if (data.revenueType === data.revenueType) {
                this.headerDirect.push(data.revenueType)
                const listDirect = {
                  revenueType: data.revenueType,
                  value: data.value,
                  percent: data.percent,
                  year: obj.year
                }
                this.listDirectRevenue.push(listDirect)
              }
            })
          } else if (type.type === 'Indirect revenue') {
            type.data.map(data => {
              if (data.revenueType === data.revenueType) {
                this.headerIndirect.push(data.revenueType)
                const listIndirect = {
                  revenueType: data.revenueType,
                  value: data.value,
                  percent: data.percent,
                  year: obj.year
                }
                this.listIndirectRevenue.push(listIndirect)
              }
            })
          } else if (type.type === 'Total') {
            type.data.map(data => {
              if (data.revenueType === data.revenueType) {
                this.headerTotal.push(data.revenueType)
                const listTotalData = {
                  revenueType: data.revenueType,
                  value: data.value,
                  year: obj.year
                }
                this.listTotal.push(listTotalData)
              }
            })
          }
        })
      })
      this.totalRevenuePercent = []
      this.listTotal.map(totalRevenue => {
        this.total.map(total => {
          if (totalRevenue.year === total.year) {
            const totalPercent = Number(total.total / totalRevenue.value) * 100
            this.totalRevenuePercent.push(totalPercent, '')
          }
        })
      })
      this.totalRevenuePercent.unshift(`% of SET group's operating revenue`)
      this.type = this.type.reduce(function (a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])
      this.header = this.header.reduce(function (a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])
      this.headerDirect = this.headerDirect.reduce(function (a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])
      this.checkHasRemark(symbol)
      this.headerIndirect = this.headerIndirect.reduce(function (a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])
      this.headerTotal = this.headerTotal.reduce(function (a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])
      this.header.map(head => {
        this.listHeader.push(head, '%')
      })
      this.listShowDirectRevenue = []
      this.listShowIndirectRevenue = []
      this.listHeader.unshift('Revenue contribution (Thousand Baht)')
      this.headerDirect.map(headerDirect => {
        const listDirect = []
        this.header.map(year => {
          let tmpDirectValue, tmpDirectPercent
          this.listDirectRevenue.map(direct => {
            if (direct.year === year && direct.revenueType === headerDirect) {
              if (direct.value === 0 || direct.value === null) {
                tmpDirectValue = null
              } else {
                tmpDirectValue = direct.value
              }
              if (direct.percent === 0 || direct.percent === null) {
                tmpDirectPercent = null
              } else {
                tmpDirectPercent = direct.percent.toFixed(2)
              }
            }
          })
          listDirect.push(tmpDirectValue, tmpDirectPercent)
        })
        listDirect.unshift(headerDirect)
        this.listShowDirectRevenue.push(listDirect)

      })
      this.headerIndirect.map(headerIndirect => {
        const listIndirect = []
        this.header.map(year => {
          let tmpIndirectValue, tmpIndirectPercent
          this.listIndirectRevenue.map(indirect => {
            if (indirect.year === year && indirect.revenueType === headerIndirect) {
              if (indirect.value === 0 || indirect.value === null) {
                tmpIndirectValue = null
              } else {
                tmpIndirectValue = indirect.value
              }

              if (indirect.percent === 0 || indirect.percent === null) {
                tmpIndirectPercent = null
              } else {
                tmpIndirectPercent = indirect.percent.toFixed(2)
              }
            }
          })
          listIndirect.push(tmpIndirectValue, tmpIndirectPercent)
        })
        let headerForTradingFee
        this.checkRemark === true ? headerForTradingFee = headerIndirect + '*' : headerForTradingFee = headerIndirect
        listIndirect.unshift(headerForTradingFee)
        this.listShowIndirectRevenue.push(listIndirect)
      })
      this.showTotalRevenueValue = []
      this.headerTotal.map(headerTotal => {
        this.header.map(year => {
          let tmpTotalValue
          this.listTotal.map(total => {
            if (total.year === year && total.revenueType === headerTotal) {
              tmpTotalValue = total.value
            }
          })
          this.showTotalRevenueValue.push(tmpTotalValue, '')
        })
        this.showTotalRevenueValue.unshift(headerTotal)
      })
      this.showTotalValue = []
      this.total.map(total => {
        if (total.total !== 0) {
          this.showTotalValue.push(total.total, (100).toFixed(2))
        } else if (total.total === 0) {
          this.showTotalValue.push(null, null)
        }
      })
      this.showTotalValue.unshift('Total revenue contribution')
      this.excelRevenue = []
      this.excelRevenue.push(this.listHeader)
      const dataTotalDirectExcel = []
      this.listTotalDirect.map(totalDirect => {
        dataTotalDirectExcel.push(totalDirect.total, totalDirect.percent)
      })
      dataTotalDirectExcel.unshift('Direct revenue')
      this.excelRevenue.push(dataTotalDirectExcel)
      this.listShowDirectRevenue.map(directRevenue => {
        this.excelRevenue.push(directRevenue)
      })
      const dataTotalIndirectExcel = []
      this.listTotalIndirect.map(totalIndirect => {
        dataTotalIndirectExcel.push(totalIndirect.total, totalIndirect.percent)
      })
      dataTotalIndirectExcel.unshift('Indirect revenue')
      this.excelRevenue.push(dataTotalIndirectExcel)
      this.listShowIndirectRevenue.map(indirectRevenue => {
        this.excelRevenue.push(indirectRevenue)
      })
      this.excelRevenue.push(this.showTotalValue)
      this.excelRevenue.push(this.showTotalRevenueValue)
      this.excelRevenue.push(this.totalRevenuePercent)
      if (this.checkRemark === true) {
        this.excelRevenue.push([this.remark])
      }
    })
  }
  checkStringForNum(word) {
    if (typeof word === 'string') {
      return (this.checkString = true)
    } else {
      return (this.checkString = false)
    }
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('SET_REVENUE')
    )
  }
  forTotal(value) {
    return value.reduce((a, b) => a + b, 0)
  }
  checkTotalLength(list) {
    return list.length === 0 ? true : false
  }
  checkHasRemark(symbol) {
    this.checkRemark = false
    this.headerDirect.map(header => {
      if (header === 'Trading fee (excluding SEC fee)') {
        this.checkRemark = true
        this.remark = 'Remark: *อาจมีการนับซ้ำระหว่างรายได้ Indirect และ Direct หากนักลงทุนซื้อขายหุ้น ' + symbol + ' ผ่านบล. ' + symbol
      }
    })
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/revenue-contribution/revenue-contribution-data/revenue-contribution-data.component.ts